export function hasSidebarBadge(badge) {
  if (typeof badge === "number") return badge > 0;
  if (typeof badge === "string") return badge.trim().length > 0;
  return false;
}

export function getSidebarBadgeText(badge) {
  if (!hasSidebarBadge(badge)) return "";
  return String(badge);
}
